"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import * as React from "react";
import { DevLinkContext } from "../devlinkContext";
import * as utils from "../utils";
export const Block = /*#__PURE__*/ React.forwardRef(function Block(_param, ref) {
    var { tag = "div" } = _param, props = _object_without_properties(_param, [
        "tag"
    ]);
    return /*#__PURE__*/ React.createElement(tag, _object_spread_props(_object_spread({}, props), {
        ref
    }));
});
export const Span = /*#__PURE__*/ React.forwardRef(function Span(props, ref) {
    return /*#__PURE__*/ React.createElement("span", _object_spread_props(_object_spread({}, props), {
        ref: ref
    }));
});
export const Blockquote = /*#__PURE__*/ React.forwardRef(function Blockquote(props, ref) {
    return /*#__PURE__*/ React.createElement("blockquote", _object_spread_props(_object_spread({}, props), {
        ref: ref
    }));
});
export const Link = /*#__PURE__*/ React.forwardRef(function Link(_param, ref) {
    var { options = {
        href: "#"
    }, className = "", button = false, children, block = "" } = _param, props = _object_without_properties(_param, [
        "options",
        "className",
        "button",
        "children",
        "block"
    ]);
    const { renderLink: UserLink } = React.useContext(DevLinkContext);
    if (button) className += " w-button";
    if (block === "inline") className += " w-inline-block";
    if (UserLink) {
        return /*#__PURE__*/ React.createElement(UserLink, _object_spread_props(_object_spread({
            className: className
        }, options, props), {
            ref: ref
        }), children);
    }
    const { href, target, preload = "none" } = options;
    const shouldRenderResource = preload !== "none" && typeof href === "string" && !href.startsWith("#");
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("a", _object_spread_props(_object_spread({
        href: href,
        target: target,
        className: className
    }, props), {
        ref: ref
    }), children), shouldRenderResource && /*#__PURE__*/ React.createElement("link", {
        rel: preload,
        href: href
    }));
});
export const List = /*#__PURE__*/ React.forwardRef(function List(_param, ref) {
    var { tag = "ul", unstyled = true, className = "" } = _param, props = _object_without_properties(_param, [
        "tag",
        "unstyled",
        "className"
    ]);
    return /*#__PURE__*/ React.createElement(tag, _object_spread_props(_object_spread({
        role: "list",
        className: className + (unstyled ? " w-list-unstyled" : "")
    }, props), {
        ref
    }));
});
export const ListItem = /*#__PURE__*/ React.forwardRef(function ListItem(props, ref) {
    return /*#__PURE__*/ React.createElement("li", _object_spread_props(_object_spread({}, props), {
        ref
    }));
});
export const Image = /*#__PURE__*/ React.forwardRef(function Image(_param, ref) {
    var { alt } = _param, props = _object_without_properties(_param, [
        "alt"
    ]);
    const { renderImage: UserImage } = React.useContext(DevLinkContext);
    return UserImage ? /*#__PURE__*/ React.createElement(UserImage, _object_spread_props(_object_spread({
        alt: alt || ""
    }, props), {
        ref: ref
    })) : /*#__PURE__*/ React.createElement("img", _object_spread_props(_object_spread({
        alt: alt || ""
    }, props), {
        ref: ref
    }));
});
export const Section = /*#__PURE__*/ React.forwardRef(function Section(_param, ref) {
    var { tag = "section" } = _param, props = _object_without_properties(_param, [
        "tag"
    ]);
    return /*#__PURE__*/ React.createElement(tag, _object_spread_props(_object_spread({}, props), {
        ref
    }));
});
export const Container = /*#__PURE__*/ React.forwardRef(function Container(_param, ref) {
    var { tag = "div", className = "" } = _param, props = _object_without_properties(_param, [
        "tag",
        "className"
    ]);
    return /*#__PURE__*/ React.createElement(tag, _object_spread({
        className: className + " w-container",
        ref
    }, props));
});
export const BlockContainer = /*#__PURE__*/ React.forwardRef(function BlockContainer(_param, ref) {
    var { tag = "div", className = "" } = _param, props = _object_without_properties(_param, [
        "tag",
        "className"
    ]);
    return /*#__PURE__*/ React.createElement(tag, _object_spread_props(_object_spread({
        className: className + " w-layout-blockcontainer"
    }, props), {
        ref
    }));
});
export const HFlex = /*#__PURE__*/ React.forwardRef(function HFlex(_param, ref) {
    var { tag = "div", className = "" } = _param, props = _object_without_properties(_param, [
        "tag",
        "className"
    ]);
    return /*#__PURE__*/ React.createElement(tag, _object_spread_props(_object_spread({
        className: className + " w-layout-hflex"
    }, props), {
        ref
    }));
});
export const VFlex = /*#__PURE__*/ React.forwardRef(function VFlex(_param, ref) {
    var { tag = "div", className = "" } = _param, props = _object_without_properties(_param, [
        "tag",
        "className"
    ]);
    return /*#__PURE__*/ React.createElement(tag, _object_spread_props(_object_spread({
        className: className + " w-layout-vflex"
    }, props), {
        ref
    }));
});
export const Layout = /*#__PURE__*/ React.forwardRef(function Layout(_param, ref) {
    var { tag = "div", className = "" } = _param, props = _object_without_properties(_param, [
        "tag",
        "className"
    ]);
    return /*#__PURE__*/ React.createElement(tag, _object_spread_props(_object_spread({
        className: className + " w-layout-layout wf-layout-layout"
    }, props), {
        ref
    }));
});
export const Cell = /*#__PURE__*/ React.forwardRef(function Cell(_param, ref) {
    var { tag = "div", className = "" } = _param, props = _object_without_properties(_param, [
        "tag",
        "className"
    ]);
    return /*#__PURE__*/ React.createElement(tag, _object_spread_props(_object_spread({
        className: className + " w-layout-cell"
    }, props), {
        ref
    }));
});
export const HtmlEmbed = /*#__PURE__*/ React.forwardRef(function HtmlEmbed(_param, ref) {
    var { tag = "div", className = "", value = "" } = _param, props = _object_without_properties(_param, [
        "tag",
        "className",
        "value"
    ]);
    return /*#__PURE__*/ React.createElement(tag, _object_spread_props(_object_spread({
        className: className + " w-embed",
        dangerouslySetInnerHTML: {
            __html: utils.removeUnescaped(value)
        }
    }, props), {
        ref
    }));
});
export const Grid = /*#__PURE__*/ React.forwardRef(function Grid(_param, ref) {
    var { tag = "div", className = "" } = _param, props = _object_without_properties(_param, [
        "tag",
        "className"
    ]);
    return /*#__PURE__*/ React.createElement(tag, _object_spread_props(_object_spread({
        className: className + " w-layout-grid"
    }, props), {
        ref
    }));
});
export const Icon = /*#__PURE__*/ React.forwardRef(function Icon(_param, ref) {
    var { widget, className = "" } = _param, props = _object_without_properties(_param, [
        "widget",
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("div", _object_spread_props(_object_spread({
        className: className + ` w-icon-${widget.icon}`
    }, props), {
        ref
    }));
});
export const Column = /*#__PURE__*/ React.forwardRef(function Column(_param, ref) {
    var { tag = "div", className = "", columnClasses = "" } = _param, props = _object_without_properties(_param, [
        "tag",
        "className",
        "columnClasses"
    ]);
    return /*#__PURE__*/ React.createElement(tag, _object_spread_props(_object_spread({
        className: className + " w-col " + columnClasses
    }, props), {
        ref
    }));
});
const transformWidths = (width, index)=>{
    var _width_split;
    const widths = (_width_split = width === null || width === void 0 ? void 0 : width.split("|")) !== null && _width_split !== void 0 ? _width_split : [];
    return widths.length > 1 ? widths[index] : width;
};
const columnClass = (width, key)=>{
    if (/stack$/.test(width)) return "w-col-stack";
    if (/main$/.test(key)) return `w-col-${width}`;
    return `w-col-${key}-${width}`;
};
export const Row = /*#__PURE__*/ React.forwardRef(function Row(_param, ref) {
    var { tag = "div", className = "", columns, children } = _param, props = _object_without_properties(_param, [
        "tag",
        "className",
        "columns",
        "children"
    ]);
    return /*#__PURE__*/ React.createElement(tag, _object_spread_props(_object_spread({
        className: className + " w-row"
    }, props), {
        ref
    }), columns ? React.Children.map(children, (child, index)=>{
        if (child && typeof child === "object" && child.type !== Column) return child;
        const columnClasses = Object.entries(columns !== null && columns !== void 0 ? columns : {}).reduce((acc, [key, value])=>{
            const width = transformWidths(value === "custom" ? "6|6" : value, index);
            acc.add(width ? columnClass(width, key) : "");
            return acc;
        }, new Set());
        return /*#__PURE__*/ React.cloneElement(child, _object_spread({
            columnClasses: [
                ...columnClasses
            ].join(" ")
        }, child.props));
    }) : children);
});
export const DOM = /*#__PURE__*/ React.forwardRef(function DOM(_param, ref) {
    var { tag = "div", className = "" } = _param, props = _object_without_properties(_param, [
        "tag",
        "className"
    ]);
    return /*#__PURE__*/ React.createElement(tag, _object_spread_props(_object_spread({
        className
    }, props), {
        ref
    }));
});
export const NotSupported = /*#__PURE__*/ React.forwardRef(function NotSupported({ _atom = "" }, ref) {
    return /*#__PURE__*/ React.createElement("div", {
        ref: ref
    }, `This builtin is not currently supported: ${_atom}`);
});
